module.exports = __webpack_public_path__ + "img/wj.084186db.png";